<template>
  <span v-if="lengthGood">{{this.value.trim()}}</span>
  <span v-else @click="handleClick">
    <abbr :title="this.value.trim()">{{this.truncatedAtLength}}</abbr>
  </span>
</template>

<script>
  export default {
    name: "long-text",
    props: ['value', 'length'],
    computed: {
      lengthGood() {
        return this.value.trim().length <= this.length;
      },
      truncatedAtLength() {
        return `${this.value.trim().slice(0, this.length - 1)} ...`;
      }
    },
    methods: {
      handleClick() {
        this.$buefy.dialog.alert(this.value.trim());
      }
    }
  }
</script>

<style scoped>

</style>